export const sharedItemsCollection = {
    EXPIRING_COMMUNICATION_DETAILS: 'EXPIRING_COMMUNICATION_DETAILS',
    NOT_EXPIRING_COMMUNICATION_DETAILS: 'NOT_EXPIRING_COMMUNICATION_DETAILS',
    PUSHED_DOCUMENTS: 'PUSHED_DOCUMENTS',
    SHARED_DOCUMENTS: 'SHARED_DOCUMENTS',
};
